/* Kunst van Staal · gedrag van de kvs-secties.
   Eén bestand, per sectie geïnitialiseerd (ook na wijzigen in de theme editor).
   Tabs, schuifrijen (pijlen, slepen, dunne balk), kleurstalen op de kaart en de Instagram-feed. */
(function () {
  if (window.__kvsHome) return;
  window.__kvsHome = true;

  var fijn = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Tabs (bestsellers) ---------- */
  function initTabs(root) {
    var sw = root.querySelector('[data-kvs-switch]'); if (!sw) return;
    var btns = sw.querySelectorAll('[data-kvs-tab]');
    var thumb = sw.querySelector('.kvs-switch__thumb');
    var more = root.querySelector('[data-kvs-more]');
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
        if (thumb) thumb.style.transform = 'translateX(calc(' + (i * 100) + '% + ' + i + ' * var(--kvs-switch-gap, 0px)))';
        root.querySelectorAll('[data-kvs-panel]').forEach(function (p) {
          var on = p.dataset.kvsPanel === btn.dataset.kvsTab; p.hidden = !on; p.classList.toggle('is-active', on);
        });
        if (more && btn.dataset.moreUrl) { more.href = btn.dataset.moreUrl; more.querySelector('span').textContent = btn.dataset.moreText; }
      });
    });
  }

  /* ---------- Kleurstalen op de productkaart (zelfde gedrag als pdp-related) ---------- */
  function initCards(root) {
    root.querySelectorAll('.pdp-related__card').forEach(function (card) {
      if (card.dataset.kvsInit) return; card.dataset.kvsInit = 1;
      var foto = card.querySelector('[data-rel-photo]');
      var dots = card.querySelectorAll('.pdp-related__dot');
      if (!foto || !dots.length) return;
      function toon(src) { if (src) { foto.removeAttribute('srcset'); foto.src = src; } }
      function terug() { var b = foto.getAttribute('data-base'); if (b) { foto.removeAttribute('srcset'); foto.src = b; } dots.forEach(function (d) { d.classList.remove('is-on'); }); }
      dots.forEach(function (dot) {
        var src = dot.getAttribute('data-rel-img');
        if (!src) return;   /* zonder variantfoto: stip wel, wissel niet */
        dot.addEventListener('mouseenter', function () { if (!fijn.matches) return; dots.forEach(function (d) { d.classList.remove('is-on'); }); dot.classList.add('is-on'); toon(src); });
        dot.addEventListener('click', function (e) {
          if (fijn.matches) { e.preventDefault(); return; }
          if (dot.classList.contains('is-on')) return;   /* tweede tik volgt de kaartlink */
          e.preventDefault(); dots.forEach(function (d) { d.classList.remove('is-on'); }); dot.classList.add('is-on'); toon(src);
        });
      });
      card.addEventListener('mouseleave', function () { if (fijn.matches) terug(); });
    });
  }

  /* ---------- Schuifrijen: pijlen, slepen met de muis, dunne sleepbare balk ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-kvs-rail]').forEach(function (rail) {
      if (rail.dataset.kvsInit) return; rail.dataset.kvsInit = 1;
      var bar = root.querySelector('[data-kvs-rbar="' + rail.dataset.kvsRail + '"]');
      var thumb = bar && bar.querySelector('.kvs-rbar__thumb');
      function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth; }
      root.querySelectorAll('[data-kvs-prev="' + rail.dataset.kvsRail + '"],[data-kvs-next="' + rail.dataset.kvsRail + '"]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, Math.floor(rail.clientWidth / step()));
          rail.scrollBy({ left: (b.hasAttribute('data-kvs-prev') ? -1 : 1) * n * step(), behavior: 'smooth' });
        });
      });
      function sync() {
        var over = rail.scrollWidth - rail.clientWidth > 4;
        rail.classList.toggle('is-grab', over && fijn.matches);
        if (!bar) return;
        bar.hidden = !over; if (!over) return;
        var w = Math.max(40, bar.clientWidth * rail.clientWidth / rail.scrollWidth);
        var x = (bar.clientWidth - w) * rail.scrollLeft / (rail.scrollWidth - rail.clientWidth);
        thumb.style.width = w + 'px'; thumb.style.transform = 'translateX(' + x + 'px)';
      }
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
      sync();
      if (bar) {
        var sx = 0, sl = 0;
        var toScroll = function (dx) { return dx * (rail.scrollWidth - rail.clientWidth) / Math.max(1, bar.clientWidth - thumb.offsetWidth); };
        bar.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          if (e.target !== thumb) { var r = bar.getBoundingClientRect(); rail.scrollTo({ left: toScroll(e.clientX - r.left - thumb.offsetWidth / 2), behavior: 'smooth' }); return; }
          bar.classList.add('is-drag'); bar.setPointerCapture(e.pointerId); sx = e.clientX; sl = rail.scrollLeft; rail.style.scrollSnapType = 'none';
        });
        bar.addEventListener('pointermove', function (e) { if (bar.classList.contains('is-drag')) rail.scrollLeft = sl + toScroll(e.clientX - sx); });
        var end = function () { if (!bar.classList.contains('is-drag')) return; bar.classList.remove('is-drag'); rail.style.scrollSnapType = ''; };
        bar.addEventListener('pointerup', end); bar.addEventListener('pointercancel', end);
      }
      var down = false, moved = false, x0 = 0, l0 = 0;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || !rail.classList.contains('is-grab')) return; down = true; moved = false; x0 = e.clientX; l0 = rail.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (!moved && Math.abs(dx) > 5) { moved = true; rail.classList.add('is-dragging'); } if (moved) rail.scrollLeft = l0 - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; if (moved) setTimeout(function () { rail.classList.remove('is-dragging'); }, 0); });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Instagram: eigen koppeling via de Instagram API (geen app of Kalles nodig) ----------
     Toegangstoken en aantal staan in de sectie-instellingen. Resultaat wordt 6 uur in de browser bewaard,
     zodat Instagram niet bij elk paginabezoek wordt aangeroepen. Lukt het ophalen niet, dan blijven de
     handmatige foto's uit de sectie staan. */
  function initInstagram(root) {
    var box = root.querySelector('[data-kvs-ig]'); if (!box || box.dataset.kvsIg) return; box.dataset.kvsIg = 1;   /* eigen vlag: het vak is ook een schuifrij en die zet al kvsInit */
    var sec = box.closest('.kvs-sec') || root;
    var token = box.dataset.token, limit = +box.dataset.limit || 10, label = box.dataset.label || 'Bekijk op Instagram';
    /* Niets te tonen (geen token en geen handmatige foto's): sectie verbergen in plaats van een lege kop. */
    function leegCheck(reden) {
      if (box.querySelector('.kvs-ig')) return;
      /* In de theme editor niet verbergen maar uitleggen, anders lijkt de sectie spoorloos. */
      if (window.Shopify && Shopify.designMode) {
        box.innerHTML = '<p style="grid-column:1/-1;padding:24px;border:1px dashed currentColor;border-radius:12px;opacity:.7">Instagram-feed laadt niet' + (reden ? ': ' + String(reden).replace(/</g, '') : '') + '. Controleer het token, of voeg handmatige foto\'s toe. Bezoekers zien deze sectie nu niet.</p>';
        return;
      }
      sec.style.display = 'none';
    }
    if (!token) { leegCheck('geen toegangstoken'); return; }
    var key = 'kvs-ig-' + token.slice(-8), cache = null;
    try { cache = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
    var tpl = root.querySelector('template[data-kvs-ig-icon]'), icon = tpl ? tpl.innerHTML : '';
    function render(list) {
      var html = list.slice(0, limit).map(function (m) {
        var src = m.media_type === 'VIDEO' ? m.thumbnail_url : m.media_url; if (!src) return '';
        var alt = (m.caption || 'Instagram-post van Kunst van Staal').split('\n')[0].slice(0, 120).replace(/"/g, '&quot;');
        return '<a class="kvs-ig" href="' + m.permalink + '" target="_blank" rel="noopener"><img src="' + src + '" alt="' + alt + '" loading="lazy"><span class="kvs-ig__over">' + icon + '<b>' + label + '</b></span></a>';
      }).join('');
      if (html) { box.innerHTML = html; sec.style.display = ''; box.dispatchEvent(new Event('scroll')); }
    }
    /* Vers genoeg (6 uur): direct tonen, geen verzoek naar Instagram. */
    if (cache && cache.d && Date.now() - cache.t < 6 * 3600e3) { render(cache.d); return; }
    /* Ouder cache-resultaat (tot 30 dagen) alvast tonen; wordt vervangen zodra de verse feed binnen is.
       Valt Instagram uit (token verlopen, app geblokkeerd), dan blijven deze posts staan. */
    var stale = cache && cache.d && Date.now() - cache.t < 30 * 864e5;
    if (stale) render(cache.d);
    fetch('https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url,permalink,caption&limit=' + limit + '&access_token=' + encodeURIComponent(token))
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j && j.error ? j.error.message : r.status); }); })
      .then(function (j) {
        if (!j || !j.data || !j.data.length) { if (!stale) leegCheck(); return; }
        try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: j.data })); } catch (e) {}
        render(j.data);
      })
      .catch(function (err) {
        if (window.console) console.warn('[kvs-instagram] feed niet geladen:', err);
        if (!stale) leegCheck(err);   /* handmatige foto's blijven staan; zonder foto's verdwijnt de sectie */
      });
    /* Houd het token geldig: een langlevend token mag ververst worden zolang het nog geldig is (max 1x per dag). */
    try {
      var rk = 'kvs-ig-refresh-' + token.slice(-8);
      if (Date.now() - (+localStorage.getItem(rk) || 0) > 864e5) {
        localStorage.setItem(rk, Date.now());
        fetch('https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=' + encodeURIComponent(token)).catch(function () {});
      }
    } catch (e) {}
  }

  /* ---------- "Nieuw": nieuwste producten uit de hele winkel ----------
     Liquid kan de hele winkel niet op datum sorteren (max. 250 producten per keer, en "all" staat alfabetisch).
     Shopify doet dat wel op /collections/all?sort_by=created-descending; via de Section Rendering API halen we
     daar dezelfde kaarten op (zelfde snippet en regels) en vervangen we de terugvalcollectie. */
  function initNewest(root) {
    root.querySelectorAll('[data-kvs-newest]').forEach(function (rail) {
      if (rail.dataset.kvsNewestInit) return; rail.dataset.kvsNewestInit = 1;
      fetch(rail.getAttribute('data-kvs-newest'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.kvs-rail--products');
          if (!src || !src.querySelector('.pdp-related__card')) return;
          rail.innerHTML = src.innerHTML;
          rail.scrollLeft = 0;
          initCards(rail.closest('.kvs-sec') || root);
          rail.dispatchEvent(new Event('scroll'));
        })
        .catch(function () { /* terugvalcollectie blijft staan */ });
    });
  }

  /* ---------- Hero: meet wat erboven staat, zodat de hero precies het scherm vult ---------- */
  function initHero(root) {
    var hero = root.matches('.kvs-hero') ? root : root.querySelector('.kvs-hero'); if (!hero) return;
    function set() {
      var top = hero.getBoundingClientRect().top + window.scrollY;
      if (top >= 0 && top < 400) hero.style.setProperty('--kvs-hero-top', Math.round(top) + 'px');
    }
    set();
    window.addEventListener('load', set);
    window.addEventListener('resize', set);
    initHeroCarousel(hero);
  }

  /* ---------- Hero-carrousel (mobiel): balkjes lopen vol en schakelen door; swipen en tikken blijven werken ----------
     Pauzeert bij aanraken, als de hero uit beeld is en als het tabblad op de achtergrond staat.
     Bij "verminder beweging" schakelt hij niet vanzelf door. */
  function initHeroCarousel(hero) {
    var track = hero.querySelector('[data-kvs-hero-track]'), bar = hero.querySelector('[data-kvs-hero-dots]');
    if (!track || !bar) return;
    /* Kaarthoogte één keer vastzetten op de helft van het scherm bij het laden. Op iOS verandert de schermhoogte
       als de browserbalk bij de eerste scroll wegklapt; dan blijft de kaart staan. Alleen een andere breedte
       (scherm draaien) rekent opnieuw. */
    var lockW = 0;
    function lockH() {
      if (window.innerWidth === lockW) return;
      lockW = window.innerWidth;
      hero.style.setProperty('--kvs-hero-card-h', Math.round(window.innerHeight * .5) + 'px');
    }
    lockH();
    window.addEventListener('resize', lockH);
    var cards = track.children, dots = bar.children, cur = 0, ticking = false, jumping = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = !reduce && parseInt(bar.getAttribute('data-autoplay'), 10) > 0 && cards.length > 1;
    var held = false, visible = true;
    if (auto) bar.classList.add('is-auto');
    function startOf() { return track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0); }
    function active() {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) return cards.length - 1;
      var start = startOf(), best = 0, dist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].getBoundingClientRect().left - start);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }
    function paint(i) {
      cur = i;
      for (var k = 0; k < dots.length; k++) {
        var d = dots[k];
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        d.classList.toggle('is-done', k < i);
        d.classList.remove('is-run');
      }
      for (var m = 0; m < cards.length; m++) cards[m].classList.toggle('is-active', m === i);
      /* Animatie opnieuw starten: eerst weghalen, reflow, dan weer zetten */
      if (auto && dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-run'); }
    }
    function pause() { bar.classList.toggle('is-paused', held || !visible || document.hidden); }
    /* Eigen glijbeweging (ease-in-out) in plaats van de standaard smooth scroll; snap staat tijdens het glijden uit */
    var anim = 0;
    function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function glide(to, done) {
      cancelAnimationFrame(anim);
      var from = track.scrollLeft, dist = to - from, t0 = 0, dur = 800;
      if (reduce || Math.abs(dist) < 2) { track.scrollLeft = to; if (done) done(); return; }
      track.style.scrollSnapType = 'none';
      anim = requestAnimationFrame(function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        track.scrollLeft = from + dist * ease(p);
        if (p < 1) anim = requestAnimationFrame(step);
        else { track.style.scrollSnapType = ''; if (done) done(); }
      });
    }
    function offsetOf(c) { return track.scrollLeft + c.getBoundingClientRect().left - startOf(); }
    function go(i) {
      var c = cards[i]; if (!c) return;
      jumping = Date.now() + 900;
      if (i < cur && cur - i > 1 && !reduce) {
        /* Terug naar de eerste: kort vervagen in plaats van terugspoelen langs alle kaarten */
        track.classList.add('is-fading');
        setTimeout(function () {
          track.style.scrollSnapType = 'none';
          track.scrollLeft = offsetOf(c);
          paint(i);
          requestAnimationFrame(function () { track.style.scrollSnapType = ''; track.classList.remove('is-fading'); });
        }, 280);
        return;
      }
      paint(i);
      glide(offsetOf(c));
    }
    function sync() {
      ticking = false;
      if (Date.now() < jumping) return; /* tijdens een sprong niet tussendoor omschakelen */
      var i = active(); if (i !== cur) paint(i);
    }
    track.addEventListener('pointerdown', function () { cancelAnimationFrame(anim); track.style.scrollSnapType = ''; jumping = 0; });
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    Array.prototype.forEach.call(dots, function (dot, i) { dot.addEventListener('click', function () { go(i); }); });
    if (auto) {
      bar.addEventListener('animationend', function (e) {
        /* De animatie zit op span::after; het event komt binnen op de span in het knopje */
        if (e.target.parentNode === dots[cur]) go((cur + 1) % cards.length);
      });
      track.addEventListener('pointerdown', function () { held = true; pause(); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { track.addEventListener(ev, function () { if (held) { held = false; pause(); } }); });
      track.addEventListener('touchstart', function () { held = true; pause(); }, { passive: true });
      track.addEventListener('touchend', function () { held = false; pause(); }, { passive: true });
      document.addEventListener('visibilitychange', pause);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; pause(); }, { threshold: 0.4 }).observe(track);
      }
    }
    paint(0);
    track.classList.add('is-ready');
  }

  /* Voor de collectiepagina: nieuw geladen kaarten (filteren, meer laden) ook kleurstalen geven */
  window.kvsInitCards = function (root) { initCards(root || document); };

  function init(root) {
    root = root || document;
    var secs = root.matches && root.matches('.kvs-sec') ? [root] : root.querySelectorAll('.kvs-sec');
    Array.prototype.forEach.call(secs, function (s) { initHero(s); initTabs(s); initCards(s); initRails(s); initInstagram(s); initNewest(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
